const normalizeRole = (role) => {
  if (!role) return 'member';
  
  const roleStr = String(role).toUpperCase();
  
  if (roleStr.includes('ADMIN') || roleStr === '2') {
    return 'admin';
  }
  
  if (roleStr.includes('LEAD')) {
    return 'lead';
  }
  
  if (roleStr.includes('MEMBER') || roleStr === '1') {
    return 'member';
  }
  
  if (roleStr === 'UNSPECIFIED' || roleStr === '0') {
    return 'member';
  }
  
  return role.toLowerCase();
};

const getRoleValue = (obj, roleType) => {
  const possibleKeys = [
    'role',
    roleType,
    `${roleType}Role`,
    `${roleType}_role`
  ];
  
  for (const key of possibleKeys) {
    if (obj && obj[key] !== undefined && obj[key] !== null) {
      return normalizeRole(obj[key]);
    }
  }
  
  return 'member';
};

export { normalizeRole, getRoleValue };
